export default __webpack_public_path__ + "static/media/interior5.bd9d6d65.webp";